import { FC } from 'react';

import { useHistoryMovementsView } from './context/HistoryMovementsViewContext';
import CollapsedTable from './components/HistoryMovementsViewCollapsedTable';
import HistoryMovementsViewExpandedTable from './components/HistoryMovementsViewExpandedTable';

const HistoryMovementsView: FC = () => {
  const { data } = useHistoryMovementsView();

  return (
    <div key="movements-card">
      <CollapsedTable />

      {data.expandView && <HistoryMovementsViewExpandedTable />}
    </div>
  );
};

export default HistoryMovementsView;
